import { forwardRef, useState } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';
import {
    InputField,
    InputFieldProps
} from '@zoopla-eng/zds-components/input-field';

import { ButtonWithWidth } from './InputPassword.styles';

type InputPasswordProps = {
    helpText?: string;
    label?: string;
} & Omit<InputFieldProps, 'label' | 'type'>;

export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
    ({ name, label, ...props }, ref) => {
        const [passwordHidden, setPasswordHidden] = useState(true);

        return (
            <Box>
                <InputField
                    {...props}
                    label={label || 'Password'}
                    type={passwordHidden ? 'password' : 'text'}
                    name={name}
                    button={
                        <ButtonWithWidth
                            category="tertiary"
                            aria-label="Show/Hide Password"
                            aria-pressed={passwordHidden ? 'false' : 'true'}
                            onClick={() =>
                                setPasswordHidden((prevState) => !prevState)
                            }
                            type="button"
                        >
                            <span
                                data-testid={
                                    passwordHidden ? 'eye-open' : 'eye-closed'
                                }
                            >
                                {passwordHidden ? 'Show' : 'Hide'}
                            </span>
                        </ButtonWithWidth>
                    }
                    ref={ref}
                />
            </Box>
        );
    }
);
